var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.85,
    height: 10.85,
    viewBox: "0 0 10.85 10.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6890",
    "data-name": "Group 6890",
    transform: "translate(0.425 0.425)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7847",
    "data-name": "Path 7847",
    d: "M1238.22,293.707a1.479,1.479,0,0,1,.44-1.048,1.455,1.455,0,0,1,1.04-.434h4.82a1.5,1.5,0,0,1,.57.113,1.485,1.485,0,0,1,.48.321,1.711,1.711,0,0,1,.32.481,1.564,1.564,0,0,1,.11.567v4.814a1.568,1.568,0,0,1-.11.567,1.726,1.726,0,0,1-.32.481,1.48,1.48,0,0,1-1.05.434h-4.82a1.474,1.474,0,0,1-.56-.113,1.416,1.416,0,0,1-.48-.321,1.538,1.538,0,0,1-.44-1.048Z",
    transform: "translate(-1236 -290.003)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7848",
    "data-name": "Path 7848",
    d: "M1236.56,297.634a1.119,1.119,0,0,1-.41-.407,1.094,1.094,0,0,1-.15-.558v-5.555a1.114,1.114,0,0,1,1.11-1.111h5.56a.9.9,0,0,1,.83.555",
    transform: "translate(-1236 -290.003)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.85
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.548e9eaaa27e7e66f4a3bd096b47e11b.svg";
export { ForwardRef as ReactComponent };